
  import Icon from '../../../common/Icon'

  export default {
    name: 'AddPaymentButton',
    components: {
      Icon,
    },
    props: {
      cta: String,
      open: Boolean,
      isGiftCard: Boolean,
      onSelect: Function,
    }
  }
